import React, { useEffect, useRef, useState } from 'react';
import { Spin } from 'antd';
import { InfiniteScroll } from '../../common';
import TicketDateDivider from './TicketDateDivider';
import TicketMessage from './TicketMessage';
import TicketThreadEmpty from './TicketThreadEmpty';
import { groupMessagesWithDividers } from '../ticket.utils';
import styles from '../styles/ticket-thread.module.scss';

/**
 * @param {Object} props
 * @param {string} props.threadKey — Reset infinite-scroll guard when navigating tickets
 * @param {{ id: string, body: string, author: { name: string, role: string }, createdAt: string }[]} props.messages
 * @param {boolean} props.hasMore
 * @param {boolean} props.loadingMore
 * @param {() => void} props.onLoadMore
 */
function TicketThread({ threadKey, messages, hasMore, loadingMore, onLoadMore }) {
    const scrollRef = useRef(null);
    const [scrollRoot, setScrollRoot] = useState(null);

    useEffect(() => {
        if (scrollRef.current) {
            setScrollRoot(scrollRef.current);
        }
    }, [messages?.length]);

    if (!messages?.length) {
        return <TicketThreadEmpty />;
    }

    const items = groupMessagesWithDividers(messages);
    let messageIndex = 0;

    return (
        <div ref={scrollRef} className={styles.threadScroll}>
            <InfiniteScroll
                onEndReached={onLoadMore}
                hasMore={hasMore}
                loading={loadingMore}
                resetKey={threadKey}
                scrollRoot={scrollRoot}
                initialDelayMs={200}
                rootMargin="0px 0px 320px 0px"
            >
                <div className={styles.thread}>
                    {items.map((item) => {
                        if (item.type === 'divider') {
                            return <TicketDateDivider key={item.id} date={item.date} />;
                        }
                        const currentIndex = messageIndex;
                        messageIndex += 1;
                        return (
                            <TicketMessage
                                key={item.id}
                                message={item.message}
                                animationIndex={currentIndex}
                            />
                        );
                    })}
                    {(hasMore || loadingMore) && (
                        <div className={styles.loadMoreRow}>
                            {loadingMore ? (
                                <Spin size="small" />
                            ) : (
                                <span className={styles.loadMoreHint}>Scroll down for more messages</span>
                            )}
                        </div>
                    )}
                </div>
            </InfiniteScroll>
        </div>
    );
}

export default TicketThread;
